module.exports = "/_next/static/images/caralt-441a4e68b838b70f6a555d952111e37e.svg";